import axios from "axios";
import { SCORING_BASE_ROOT_URL } from "src/config/constants";

const responseBody = (res) => res.data;

export const createClient = (api_root, apiConfig = {}) => {
  return {
    get: (url, config) => axios.get(`${api_root}${url}`, { ...config, ...apiConfig }).then(responseBody),
    post: (url, body, config) => axios.post(`${api_root}${url}`, body, { ...config, ...apiConfig }).then(responseBody),
    del: (url, config) => axios.delete(`${api_root}${url}`, { ...config, ...apiConfig }).then(responseBody),
    put: (url, body, config) => axios.put(`${api_root}${url}`, body, { ...config, ...apiConfig }).then(responseBody),
  };
};

export const analysisClient = createClient(`${SCORING_BASE_ROOT_URL}/api-v2`);
export const tokenHealthClient = createClient(`${SCORING_BASE_ROOT_URL}/token-health`);
export const reputationClient = createClient(`${SCORING_BASE_ROOT_URL}/reputation/v1/reputation`);
export const mergeClient = createClient(`${SCORING_BASE_ROOT_URL}/merger-v2/v1`);
export const simulationClient = createClient(`${SCORING_BASE_ROOT_URL}/analysis/simulation`);
export const monitoringClient = createClient(`${SCORING_BASE_ROOT_URL}/pool-analysis`);
export const multiPoolClient = createClient(`${SCORING_BASE_ROOT_URL}/multi-pools`);
